export const notificationsQueries = {
  list: (params: { page?: number; perPage?: number; query?: string } = {}) => [
    'notifications',
    params,
  ],
};
